import { useState, useEffect } from "react";
import apiClient from "../../utils/apiClient";
import AboutYouForm from "../../components/preferences/AboutYou";
import { useNavigate } from "react-router-dom";

export default function OnboardAboutYou() {
  const [prefs, setPrefs] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient.get(`/users/preferences`).then(res => setPrefs(res.data));
  }, []);

  const handleSave = async (updated) => {
    const res = await apiClient.put(`/users/preferences`, updated);
    setPrefs(res.data);
    navigate("/onboard/your-kitchen");
  };

  return (
    <div className="max-w-md mx-auto mt-8 space-y-6 px-4">
      <h1 className="text-2xl font-bold">About you</h1>
      <p>Let's start with a bit about you, chef. Your setting choices here help us personalise recipes just for you.</p>
      {prefs && <AboutYouForm prefs={prefs} onSubmit={handleSave} btnText={"Next"} />}
    </div>
  );
}
